import {Chip, Tooltip} from "@mui/material";
import React, {useEffect, useState} from "react";
import PendingIcon from '@mui/icons-material/Pending';
import PlayCircleIcon from '@mui/icons-material/PlayCircle';
import DownloadIcon from '@mui/icons-material/Download';
import ErrorIcon from '@mui/icons-material/Error';
import LoopIcon from '@mui/icons-material/Loop';

import '../../css/App.css';
import RecordingChip from "./RecordingChip";
import {RECORDING_STATUS} from "../../domain/RecordingStatus";

export default function ZoomMeetingRecording({recordingStatus, recordingUrls, zoomMeetingUrl, options}) {

    const [recordingPlaybackIcon, setRecordingPlaybackIcon] = useState();
    const [recordingChipTooltipLabel, setRecordingChipTooltipLabel] = useState();
    
    const defaultOptions = {
        displayMeetingId: false
    }
    
    const mergedOptions = { ...defaultOptions, ...options };

    const zoomRecordingChipStyle = {
        marginLeft: mergedOptions.displayMeetingId ? '0.5rem': '0.125rem',
        marginTop: '0.1rem',
        width: mergedOptions.displayMeetingId ? '1.2rem' : 'auto',
        height: mergedOptions.displayMeetingId ? '1.2rem' : '1.5rem',
        paddingLeft: mergedOptions.displayMeetingId ? '0.5rem' : '',
        backgroundColor: 'rgba(255, 255, 255, 0.8)'
    };

    function extractZoomMeetingId() {
        return zoomMeetingUrl.slice(zoomMeetingUrl.lastIndexOf('/') + 1, zoomMeetingUrl.length);
    }

    useEffect(() => {

        const zoomMeetingId = zoomMeetingUrl ? extractZoomMeetingId() : 'Link Pending';
        setRecordingChipTooltipLabel(zoomMeetingId);

        let playbackChipIcon = <LoopIcon />;

        if (recordingStatus === RECORDING_STATUS.COMPLETED) {
            playbackChipIcon = mergedOptions.displayMeetingId ? <DownloadIcon style={{fontSize: '0.9rem'}} /> : <PlayCircleIcon />;
        } else if (recordingStatus === RECORDING_STATUS.PENDING) {
            playbackChipIcon = <PendingIcon />;
        } else if (recordingStatus === RECORDING_STATUS.COMPLETED_WITH_ISSUES) {
            playbackChipIcon = <ErrorIcon />;
        }

        setRecordingPlaybackIcon(playbackChipIcon);

    }, [recordingStatus]);

    return (
        <Tooltip disableFocusListener placement="bottom-start" arrow PopperProps={{sx: {
            "& .MuiTooltip-tooltip": {backgroundColor: mergedOptions.displayMeetingId ? "black" : ""},
            "& .MuiTooltip-arrow": {color: mergedOptions.displayMeetingId ? "black" : ""}}}}
            title={
            <RecordingChip recordingStatus={recordingStatus} recordingUrls={recordingUrls} meetingLabel={recordingChipTooltipLabel} options={mergedOptions} />
        }>
            <Chip icon={recordingPlaybackIcon} component="a" size="small" sx={zoomRecordingChipStyle} />
        </Tooltip>
    );
}
